import { ReactElement } from 'react';
import styled from 'styled-components';

import { NumberPatternType, useFormController } from '@dreryk/react-common';
import { NumberInput } from '@dreryk/react-components';

import { integrationTranslationKeys } from '../../translations';
import {
   DocplannerUpdateSynchronizationDaysCountFormBean,
   DocplannerUpdateSynchronizationDaysCountFormController,
} from '../integration.types';

type ChildrenRenderProps = Pick<DocplannerUpdateSynchronizationDaysCountFormController, 'handleSubmit' | 'formState'>;

type DocplannerUpdateSynchronizationDaysCountFormProps = {
   readonly children: (renderProps: ChildrenRenderProps) => ReactElement;
   readonly currentSynchronizationDaysCount: number;
};

// TODO DREGAB-11988 Poprawić działanie propa "size"
const StyledNumberInput = styled(NumberInput)`
   > div > div {
      max-width: 80px;
   }
`;

export const DocplannerUpdateSynchronizationDaysCountForm = (
   props: DocplannerUpdateSynchronizationDaysCountFormProps
): ReactElement => {
   const { register, handleSubmit, formState } = useFormController<DocplannerUpdateSynchronizationDaysCountFormBean>({
      synchronizationDaysCount: props.currentSynchronizationDaysCount,
   });

   return (
      <>
         <StyledNumberInput
            testId={'synchronizationDaysCount'}
            label={integrationTranslationKeys.synchronizationDaysCount}
            controller={register('synchronizationDaysCount', { required: true })}
            pattern={NumberPatternType.POSITIVE_INTEGER}
            min={1}
            max={160}
         />
         {props.children({
            handleSubmit: handleSubmit,
            formState: formState,
         })}
      </>
   );
};
